export const BANK_DETAILS_REQUIRED = false;
export const EMPLOYEE_UPLOAD_MAX_BYTES = 10 * 1024 * 1024;
